(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cheers-business-collection"]) return;
  try {
    
document.querySelectorAll('[data-cc-image]').forEach(button=>button.addEventListener('click',()=>{const image=document.getElementById('cc-business-hero');image.src=button.dataset.ccImage;image.alt=button.textContent;document.querySelectorAll('[data-cc-image]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cheers-business-inquiry"] && !Shopify.designMode) return;
  try {
    
const input=document.getElementById('ci-date');
if(input){input.addEventListener('input',()=>{input.setCustomValidity('');if(!input.value)return;const parts=input.value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);if(!parts){input.setCustomValidity(input.dataset.error);return;}const [,m,d,y]=parts.map(Number);const date=new Date(y,m-1,d);if(date.getFullYear()!==y||date.getMonth()!==m-1||date.getDate()!==d)input.setCustomValidity(input.dataset.error);});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cheers-pilot-story"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cp-return]').forEach(link=>{const target=document.querySelector('[data-product-id]');if(target){if(!target.id)target.id='cp-customize';link.href='#'+target.id;}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cheers-wedding-story"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cp-return]').forEach(link=>{const target=document.querySelector('[data-product-id]');if(target){if(!target.id)target.id='cp-customize';link.href='#'+target.id;}});

  } catch(e) { console.error(e); }
})();
})();
